var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"article"}},[_c('div',{staticClass:"ql-editor",attrs:{"id":"a8983476"},domProps:{"innerHTML":_vm._s(_vm.articleContent)}}),_c('div',{attrs:{"id":"a4e34106"}},[_c('dal-compfloat',{attrs:{"id":"cmpa4e34106"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }